import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { CertificationTypeCreateDto, CertificationTypeDto, CertificationTypeExcelDownloadDto, CertificationTypeUpdateDto, GetCertificationTypesInputDto } from '../dtos/certification-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class CertificationTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: CertificationTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationTypeDto>({
      method: 'POST',
      url: '/api/planning/certificationTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/certificationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/certificationTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationTypeDto>({
      method: 'GET',
      url: `/api/planning/certificationTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/certificationTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCertificationTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CertificationTypeDto>>({
      method: 'GET',
      url: '/api/planning/certificationTypes',
      params: { name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: CertificationTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/certificationTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationTypeDto[]>({
      method: 'GET',
      url: '/api/planning/certificationTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: CertificationTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CertificationTypeDto>({
      method: 'PUT',
      url: `/api/planning/certificationTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}